/**
 * Global header component - used across all authenticated views
 */

import { Toolbar } from './Toolbar';
import './GlobalHeader.css';

interface GlobalHeaderProps {
  title: string;
  children?: React.ReactNode;
}

export function GlobalHeader({ title, children }: GlobalHeaderProps) {
  return (
    <header className="global-header">
      <div className="global-header-title">
        <h1>{title}</h1>
      </div>
      <Toolbar>
        <div id="global-toolbar-portal"></div>
        {children}
      </Toolbar>
    </header>
  );
}
